/* ==========================================================================
   ZAETH — Founding 100
   Scroll reveal + soft hero parallax
   ========================================================================== */
(function () {
  'use strict';

  function initFounding100(root) {
    if (!root || root.dataset.f100Init === 'true') return;
    root.dataset.f100Init = 'true';

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var noMotion = root.classList.contains('f100--no-motion');
    var animated = root.querySelectorAll('.f100-animate');

    if (noMotion || prefersReduced || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
    } else {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var delay = el.dataset.f100Delay ? parseInt(el.dataset.f100Delay, 10) : 0;
            window.setTimeout(function () {
              el.classList.add('is-visible');
            }, delay);
            obs.unobserve(el);
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }
      );

      root.querySelectorAll('.f100-band').forEach(function (band) {
        var cells = band.querySelectorAll('.f100-animate');
        cells.forEach(function (cell, i) {
          cell.dataset.f100Delay = String(Math.min(i, 5) * 80);
          observer.observe(cell);
        });
      });
    }

    if (noMotion || prefersReduced) return;

    var hero = root.querySelector('.f100-hero');
    var media = root.querySelector('[data-f100-parallax]');
    if (!hero || !media) return;

    var latestY = 0;
    var currentY = 0;
    var ticking = false;

    function render() {
      currentY += (latestY - currentY) * 0.08;
      media.style.transform = 'translate3d(0,' + (currentY * 0.18) + 'px,0)';
      if (Math.abs(latestY - currentY) > 0.1) {
        window.requestAnimationFrame(render);
      } else {
        ticking = false;
      }
    }

    function onScroll() {
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      latestY = Math.max(0, -rect.top);
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(render);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() {
    document.querySelectorAll('[data-f100-root]').forEach(initFounding100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-f100-root]');
    if (root) {
      root.dataset.f100Init = 'false';
      initFounding100(root);
    }
  });
})();
